const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\s\-\+\(\)\.]{7,}$/;

export let detectContactInfo = (handle?: string): boolean => {
  if (!handle) return false;

  const trimmed = handle.trim();

  if (EMAIL_REGEX.test(trimmed)) return true;

  const digitsOnly = trimmed.replace(/[\s\-\+\(\)\.]/g, '');
  if (PHONE_REGEX.test(trimmed) && digitsOnly.length >= 7 && /^\d+$/.test(digitsOnly)) {
    return true;
  }

  return false;
};
